import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetPublishedPageByPageIdResponse,
  GetPublishedPageBySlugResponse,
  PublishedPage,
  PublishedPageQuery,
  PublishedPagesQueryBuilder,
  QueryPublishedPagesResponse,
  getPublishedPage as universalGetPublishedPage,
  getPublishedPageByPageId as universalGetPublishedPageByPageId,
  getPublishedPageBySlug as universalGetPublishedPageBySlug,
  queryPublishedPages as universalQueryPublishedPages,
  typedQueryPublishedPages as universalTypedQueryPublishedPages,
} from './quickpages-v1-published-page-published-pages.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/quick-pages' };

/** @internal */
export function getPublishedPage(
  httpClient: HttpClient
): GetPublishedPageSignature {
  return (publishedPageId: string) =>
    universalGetPublishedPage(
      publishedPageId,
      // @ts-ignore
      { httpClient }
    );
}

interface GetPublishedPageSignature {
  /**
   * Retrieves a PublishedPage.
   * @param - ID of the PublishedPage to retrieve.
   * @returns The requested PublishedPage.
   */
  (publishedPageId: string): Promise<
    NonNullablePaths<PublishedPage, `pageId` | `contentId` | `slug`, 2>
  >;
}

/** @internal */
export function getPublishedPageBySlug(
  httpClient: HttpClient
): GetPublishedPageBySlugSignature {
  return (slug: string) =>
    universalGetPublishedPageBySlug(
      slug,
      // @ts-ignore
      { httpClient }
    );
}

interface GetPublishedPageBySlugSignature {
  /**
   * Retrieves a PublishedPage by slug.
   * @param - ID of the PublishedPage to retrieve.
   */
  (slug: string): Promise<
    NonNullablePaths<
      GetPublishedPageBySlugResponse,
      `publishedPage.pageId` | `publishedPage.contentId` | `publishedPage.slug`,
      3
    >
  >;
}

/** @internal */
export function getPublishedPageByPageId(
  httpClient: HttpClient
): GetPublishedPageByPageIdSignature {
  return (pageId: string) =>
    universalGetPublishedPageByPageId(
      pageId,
      // @ts-ignore
      { httpClient }
    );
}

interface GetPublishedPageByPageIdSignature {
  /**
   * Retrieves a PublishedPage by slug.
   * @param - ID of the PublishedPage to retrieve.
   */
  (pageId: string): Promise<
    NonNullablePaths<
      GetPublishedPageByPageIdResponse,
      `publishedPage.pageId` | `publishedPage.contentId` | `publishedPage.slug`,
      3
    >
  >;
}

/** @internal */
export function queryPublishedPages(
  httpClient: HttpClient
): QueryPublishedPagesSignature {
  return () =>
    universalQueryPublishedPages(
      // @ts-ignore
      { httpClient }
    );
}

interface QueryPublishedPagesSignature {
  /**
   * Retrieves a list of PublishedPages, given the provided [paging, filtering, and sorting][1].
   *
   * Up to 1,000 PublishedPages can be returned per request.
   *
   * To learn how to query PublishedPages, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
   */
  (): PublishedPagesQueryBuilder;
}

export function typedQueryPublishedPages(
  httpClient: HttpClient
): TypedQueryPublishedPagesSignature {
  return (query: PublishedPageQuery) =>
    universalTypedQueryPublishedPages(
      query,
      // @ts-ignore
      { httpClient }
    );
}

interface TypedQueryPublishedPagesSignature {
  /** */
  (query: PublishedPageQuery): Promise<
    NonNullablePaths<
      QueryPublishedPagesResponse,
      | `publishedPages`
      | `publishedPages.${number}.pageId`
      | `publishedPages.${number}.contentId`
      | `publishedPages.${number}.slug`,
      4
    >
  >;
}

export {
  AccountInfo,
  ActionEvent,
  CursorPaging,
  CursorPagingMetadata,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetPublishedPageByPageIdRequest,
  GetPublishedPageByPageIdResponse,
  GetPublishedPageBySlugRequest,
  GetPublishedPageBySlugResponse,
  GetPublishedPageRequest,
  GetPublishedPageResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessageEnvelope,
  PublishedPage,
  PublishedPageQuerySpec,
  PublishedPagesQueryBuilder,
  PublishedPagesQueryResult,
  QueryPublishedPagesRequest,
  QueryPublishedPagesResponse,
  RestoreInfo,
  SortOrder,
  Sorting,
  WebhookIdentityType,
  utils,
} from './quickpages-v1-published-page-published-pages.universal.js';
